import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skelton',
  templateUrl: './app-skelton.component.html',
  styleUrls: ['./app-skelton.component.scss'],
})
export class AppSkeltonComponent implements OnInit {
  @Input() skeletonType = 'notification';
  @Input() skeletonCount = 5;
  constructor() { }

  ngOnInit() {}
  counter(i: number) {
    return new Array(i);
  }
}
